__turbopack_context__.v({
  "active": "glossaryNav-module-scss-module__5KKTzW__active",
  "desktopNav": "glossaryNav-module-scss-module__5KKTzW__desktopNav",
  "disabled": "glossaryNav-module-scss-module__5KKTzW__disabled",
  "mobileNav": "glossaryNav-module-scss-module__5KKTzW__mobileNav",
  "navLink": "glossaryNav-module-scss-module__5KKTzW__navLink",
});
